import React from 'react';
import '../../App.css';
import { Link } from 'react-router-dom';

export default function Home() {
    return <>
        <body className='home'>

            <h1 className='title'>Torne o seu aumigo um her&oacute;i!</h1>

            <p className='texto'>
                Cadastre seu pet e fa&ccedil;am parte do nosso time de doadores, ajude a salvar vidas!
            </p>
            <p className='texto'>
                Procurando doador? Entre em contato com nossos parceiros
            </p>

            <div className='center'>
                <Link to='/parceiros'>
                    <button className='btn'>Parceiros</button>
                </Link>
            </div>

            <p className='texto'>
                N&atilde;o sabe se seu amigo pode doar? Descubra
            </p>
            <div className='center'>
                <Link to='/requisitos'>
                    <button className='btn'>Requisitos</button>
                </Link>
            </div>

            <p className='texto'>
                J&aacute; tem uma conta? fa&ccedil;a seu login aqui
            </p>
            <div className='center'>
                <Link to='/admin'>
                        <button className='btn'>Login</button>
                </Link>
            </div>
        </body>


        

    </>;

}